<template>
  <div v-if="model">
    <div class="position-relative">
      <input type="number" v-model="value" class="form-control form-control-solid" :placeholder="model.name"
             @keyup="emitUpdate" :disabled="isDisabled" @change="emitUpdate">
      <div class="input-check">
        <i class="fad fa-check-circle text-primary px-3"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class PropertyNumber extends Vue {
  @Prop() itemUuid!: string
  @Prop() propertyCode!: string
  @Prop({default: false}) isDisabled!: boolean

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.itemUuid)
  }

  get model() {
    if (!this.item) return null
    const itemType = this.$store.state.contractStore.itemTypes[this.item.modelCode]
    if (!itemType?.properties) return null
    return (Object.values(itemType.properties) as any[]).find((pm: any) => pm.code === this.propertyCode) || null
  }

  get value() {
    return this.item?.properties?.[this.propertyCode]
  }

  set value(v: any) {
    if (this.item) {
      Vue.set(this.item.properties, this.propertyCode, v)
    }
  }

  emitUpdate() {
    this.$emit('propertyUpdated', {code: this.propertyCode, itemUuid: this.itemUuid})
  }
}
</script>

<style scoped>
</style>
